// src/features/password_reset/model/slice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchForgotPassword, fetchResetPassword } from "./actions";

export interface IPasswordResetState {
    isLoading: boolean;
    codeSent: boolean;
    resetEmail: string;       // email, на который отправлен код
    resendAfter: number;      // секунды до повторной отправки
    isResetSuccess: boolean;  // флаг успешного сброса (для редиректа)
}

const initialState: IPasswordResetState = {
    isLoading: false,
    codeSent: false,
    resetEmail: "",
    resendAfter: 0,
    isResetSuccess: false,
};

export const PasswordResetSlice = createSlice({
    name: "passwordReset",
    initialState,
    reducers: {
        resetPasswordResetState: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            // forgotPassword
            .addCase(fetchForgotPassword.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(
                fetchForgotPassword.fulfilled,
                (state, action: PayloadAction<{ email: string; resend_after: number }>) => {
                    state.isLoading = false;
                    state.codeSent = true;
                    state.resetEmail = action.payload.email;
                    state.resendAfter = action.payload.resend_after;
                },
            )
            .addCase(fetchForgotPassword.rejected, (state) => {
                state.isLoading = false;
            })

            // resetPassword
            .addCase(fetchResetPassword.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchResetPassword.fulfilled, (state) => {
                state.isLoading = false;
                state.isResetSuccess = true;
            })
            .addCase(fetchResetPassword.rejected, (state) => {
                state.isLoading = false;
            });
    },
});

export const { resetPasswordResetState } = PasswordResetSlice.actions;
export default PasswordResetSlice.reducer;